<template>
  <SOSlotBase
      :bg-grey="true"
      container-name="mesin-list-container"
      :is-search="pageSetting.search"
  >
    <template v-slot:title-bar>
      <SOTitleBar
          page-title="Mesin Terpasang"
          :show-search="true"
          type="back"
          @back="back"
          @search="searchOn"
          v-if="!pageSetting.search"
      />
    </template>
    <template v-slot:search-bar>
      <SOSearchBar
          v-if="pageSetting.search"
          search-information="Nama mesin, ID mesin"
          :value="searchKey"
          :waiting="searching"
          :data-count="listSnapMesin.jumlah_mesin"

          @return-search-value="(v) => {searchKey = v}"
          @loading="loadingSearch"
          @do-search="onSearch"
          @close="searchOff"
      />
    </template>
    <template v-slot:filter>
      <SOFilter
          @back="() => {pageSetting.showFilter = false}"
          v-if="pageSetting.showFilter"
          :sorting="sorting"
          :filterPenghapusanTransaksi="{ reguler: null }"
          :filter-snap-mesin="true"
          @do-filter="doFilter"
          @reset-filter="resetFilter"
      />
    </template>
    <template v-slot:content>
	    <div class="d-flex-between-center align-items-center p-x-20 p-y-12 bg-white">
		    <div class="d-block">
			    <div class="f-regular f-14 f-c-black">
				    Pengurutan Nomor Mesin
			    </div>
			    <div class="f-regular f-12 f-c-midgrey">
				    Nomor akan dicetak di QRcode .
			    </div>
		    </div>
            <!--	
            
		    <div class="d-flex">
                      <SOButton
              class=""
              :text="'Download Semua QR'"
              :outline="true"
              @action="routeToDownloadQrOutlet"
          />
        &nbsp;
        
        -->

			    <SOButton
				    class=""
				    :text="'Atur Nomor Urut Mesin'"
				    :outline="true"
				    @action="routeToSortinMesin"
			    />
	    </div>
      <div v-if="!pageSetting.loading.list">
        <SODropdownMenu
            v-if="!pageSetting.loading.outlet && !$route.query.idconsole"
            :text="detailOutlet.data[0].nama"
            @action="() => {pageSetting.modal.listOutlet = true}"
        />
        <SODropDownOutletSekleton v-else/>
        <div class="p-x-20 p-t-16 w-limit">
          <SOHeaderList
              :title="'Total ' + listSnapMesin.jumlah_mesin + ' Mesin'"
              :show-filter="!idconsole"
              v-if="!pageSetting.search"
              @filter="() => {pageSetting.showFilter = true}"
          />
	        <div class="row">

          <SOCardSnapMesin
              v-for="mesin in  listSnapMesin.data"
              :key="mesin.id"
              :nama="mesin.nama"
              :jenis="mesin.jenis"
              :kategori="mesin.snap_tag.nama"
              :id-mesin="mesin.id"

              :ol="true"
              :aid="mesin.snap_report_device.aid"
              :tl="mesin.snap_report_device.tl"
              :sw="mesin.snap_report_device.sw"
              :ver="mesin.snap_report_device.ver"
              :urutan="mesin.urutan"
              :connection="reportConnectionMesin"
              :firm-ware="latestVersionMesin.data"
              :more-menu="pageSetting.more.mesinCard"

              :isSearch="pageSetting.search"
              :search-key="searchKey"

              @moreAction="actionMoreMesin(mesin.id)"
              @turnOnMesin="turnOnModalAction(mesin.id)"
              @turnOffMesin="turnOffModalAction(mesin.id)"
              @deleteModal="deleteModalAction(mesin.id)"
          />
	        </div>

          <SOFABRegular @add="toAdd" v-if="!idconsole && !pageSetting.search && validateAccess('snapBridge.create')"/>
          <SOLoadMoreLoading
						id="loading-list-snapmesin"
						:loading="listSnapMesin.jumlah_mesin > (listSnapMesin.data ?? []).length || pageSetting.loading.loadMore"
						@intersect="getListSnapMesin"
					/>
        </div>
      </div>
    </template>


    <template v-slot:skeleton>
      <div class="p-x-20 p-t-16 w-limit" v-if="pageSetting.loading.list">
        <SOCardSnapConsoleSekleton/>
      </div>
    </template>
    <template v-slot:empty-state v-if="!pageSetting.loading.list && listSnapMesin.jumlah_mesin < 1">
      <SOEmptyState
          v-if="!pageSetting.search"
          message="Tidak Mesin Terpasang"
          :sub-message="'Pasang mesin di ' + (idconsole ? 'console' : 'outlet') +' ini.'"
      />
      <SOEmptySearchState
          v-if="pageSetting.search"
      />
    </template>

    <template v-slot:modal>
      <SnapMesinModalTurnOn
          v-if="pageSetting.modal.turnOnMesin"
          :id-mesin="actionId"
          @close="turnOnModalAction"
      />
      <SnapMesinModalTurnOff
          v-if="pageSetting.modal.turnOffMesin"
          :id-mesin="actionId"
          @close="turnOffModalAction"
      />
      <SnapMesinModalListOutlet
          v-if="pageSetting.modal.listOutlet"
          :outlet="outlets.data"
          :id-outlet-selected="detailOutlet.data[0].idoutlet"
          @close="() => {pageSetting.modal.listOutlet = false}"
          @selected="() => doFilter()"
      />
    </template>

  </SOSlotBase>
</template>

<script>
import {mapGetters} from "vuex";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOHeaderList from "@/so-components/global/ui/SOHeaderList";
import SOEmptyState from "@/so-components/global/ui/SOEmptyState";
import SOFABRegular from "@/so-components/global/ui/SOFABRegular";
import SOFilter from "@/so-components/global/filter/base/SOFilter";

import SOCardSnapMesin from "./component/SOCardSnapMesin";
import SOCardSnapConsoleSekleton from "./component/SOCardSnapConsoleSekleton";
import SnapMesinModalTurnOff from "./modal/SnapMesinModalTurnOff";
import SnapMesinModalTurnOn from "./modal/SnapMesinModalTurnOn";
import SOLoadMoreLoading from "@/so-components/global/ui/SOLoadMoreLoading";
import SOSearchBar from "@/so-components/global/ui/SOSearchBar";
import SOEmptySearchState from "@/so-components/global/ui/SOEmptySearchState";
import SODropdownMenu from "@/so-components/global/ui/SODropdownMenu";
import SnapMesinModalListOutlet from "@/modules/outlet/mesin/views/modal/SnapMesinModalListOutlet";
import SODropDownOutletSekleton from "@/modules/outlet/mesin/views/component/SODropDownOutletSekleton";
import SOButton from "@/so-components/global/ui/SOButton.vue";
import SOModalExportMultipleFile from "@/so-components/global/modal/SOModalExportMultipleFile.vue";
import SOModalConfirmDeleteExport from "@/so-components/global/modal/SOModalConfirmDeleteExport.vue";

export default {
  name: "SnapMesinList",
  components: {
	  SOModalConfirmDeleteExport, SOModalExportMultipleFile, SOButton,
    SODropDownOutletSekleton,
    SnapMesinModalListOutlet,
    SODropdownMenu,
    SOEmptySearchState,
    SOSearchBar,
    SOLoadMoreLoading,
    SnapMesinModalTurnOn,
    SOFilter,
    SnapMesinModalTurnOff,
    SOFABRegular,
    SOCardSnapConsoleSekleton,
    SOEmptyState,
    SOCardSnapMesin,
    SOHeaderList,
    SOTitleBar,
    SOSlotBase
  },
  data() {
    return {
      idconsole: this.$route.query.idconsole,
      actionId: "",
      // searchKey: "",
      searching: false,

      pageSetting: {
        showFilter: false,
        search: false,
        loading: {
          list: true,
          loadMore: false,
          outlet: true,
        },
        more: {
          mesinCard: false
        },
        modal: {
          deleteMesin: false,
          turnOnMesin: false,
          turnOffMesin: false,
          listOutlet: false,
        },
        error: {
          list: false,
        }
      },
      sorting: [
        {
          label: "Abjad A - Z",
          name: "sorting",
          value: JSON.stringify({
            sortBy: "nama",
            orderBy: "ASC",
          }),
          id: "sorting-1"
        },
        {
          label: "Abjad Z - A",
          name: "sorting",
          value: JSON.stringify({
            sortBy: "nama",
            orderBy: "DESC",
          }),
          id: "sorting-2"
        },
      ]
    }
  },
  sockets: {
    connect: () => {
      console.log("socket connected")
    }
  },
  methods: {
    updateData(i, report) {
      let mesin = this.listSnapMesin.data[i]

      mesin.snap_report_device.sw = report.sw
      mesin.snap_report_device.tl = report.tl
      mesin.snap_report_device.aid = report.aid
    },

    async subscribeMesin() {
      let mesin = this.listSnapMesin.data
      for (let i = 0; i < mesin.length; i++) {
        this.sockets.subscribe("report.switch." + mesin[i].id, async report => {
          await this.updateData(i, report)
        })

        this.sockets.subscribe("report.switch.off." + mesin[i].id, async report => {
          await this.updateData(i, report)
        })
      }
    },

    async unsubscribeMesin() {
      let mesin = this.listSnapMesin.data
      for (let i = 0; i < mesin.length; i++) {
        this.sockets.unsubscribe("report.switch." + mesin[i].id)

        this.sockets.unsubscribe("report.switch.off." + mesin[i].id)
      }
    },

    //FETCH DATA
    async getListSnapMesin() {
      if (!this.pageSetting.loading.list) {
        this.pageSetting.loading.loadMore = true
      }
      if (this.listSnapMesin != null) {
        if (this.listSnapMesin.data !== undefined && this.listSnapMesin.data.lenght === 0) {
          this.searching = true
        }
      }
      const query = this.$route.query
      const res = await this.$store.dispatch("snapMesinModule/fetchListSnapMesin", query)
      this.pageSetting.loading.list = false
      this.pageSetting.loading.loadMore = false
      this.searching = false
      await this.$store.commit("helper/setScrollCalled", false)
      if (!this.$route.query.idconsole && this.detailOutlet.data === undefined) {
        await this.getDetOutlet();
      }

      if (res.success) {
        this.pageSetting.loading.list = false
        await this.$store.commit("snapMesinModule/setNextPagination", {data: this.listSnapMesin.data})
        await this.subscribeMesin();

      } else {
        console.log(res)
        this.pageSetting.error.list = true
        setTimeout(() => {
          this.pageSetting.error.list = false
        }, 10000)
        this.$toast.error(res.err)
      }
    },

    async getConnectionReportMesin() {
      const query = this.$route.query
      await this.$store.dispatch("snapMesinModule/fetchReportConnectionMesin", query)
    },

    async getDetOutlet() {
      await this.$store.dispatch("outletModule/fetchOutletAll")
      let res = await this.$store.dispatch("outletModule/fetchDetailOutlet", this.$route.query.idoutlet)
      if (res.success) {
        this.pageSetting.loading.outlet = false
      }
    },

    async getLatestVesion() {
      await this.$store.dispatch("snapMesinModule/fetchLatestVersionMesin")
    },

    async doFilter() {
      this.pageSetting.loading.list = true
      await this.clearData()
      await this.initPage()
      this.pageSetting.showFilter = false
    },

    async resetFilter() {
      await this.$store.commit("filterGlobalModule/resetFilterItem");
    },

    //ACTION
    initPage() {
      this.getListSnapMesin()
       this.getLatestVesion()
       this.getConnectionReportMesin()
      this.scroll()
    },

    async searchOn() {
      this.pageSetting.search = true
      await this.clearData()
      await this.unsubscribeMesin()
    },

    async searchOff() {
      this.pageSetting.loading.list = true
      await this.clearData()
      await this.initPage()
      this.pageSetting.search = false
    },

    async onSearch(searchKey) {
      await this.clearData();
      await this.$store.commit("snapMesinModule/setSearchKey", {searchKey})
      await this.initPage();
    },

    loadingSearch(val) {
      this.searching = val
    },

    scroll() {
      window.onscroll = async () => {
        if (this.pageSetting.error.list) {
          return ""
        }
        let payload = {
          idLoadMore: "loading-list-snapmesin",
          container: "mesin-list-container",
          pagination: this.pagination,
          callback: this.getListSnapMesin,
        }
        await this.$store.dispatch("helper/scroll", payload)
      }
    },

    back() {
      if (this.idconsole) {
        this.$router.push({
          name: "SnapConsole",
          params: {
            idoutlet: this.$route.query.idoutlet
          }
        })
      } else {
        this.$router.push("/addOutlet/" + this.$route.query.idoutlet)
      }
    },

    toAdd() {
      if (window.screen.width > 600) {
        $(".sidebar-menu").hide()
        $("#nav-bottom").hide()
        $(".view-screen").css("margin", "0px auto 0px 0px")
      }
      setTimeout(() => {
        this.$router.push({
          name: "SnapMesinScanId",
          params: {
            idoutlet: this.$route.query.idoutlet
          }
        })
      }, 400)
    },

    async clearData() {
      await this.$store.commit("snapMesinModule/resetListSnapMesin")
      await this.$store.commit("snapMesinModule/resetReportConnectionMesin")
      await this.$store.commit("snapMesinModule/resetLayananByAid")
      await this.$store.commit("snapMesinModule/resetPagination")
      await this.$store.commit("snapMesinModule/resetSearchKey")
      await this.$store.commit("outletModule/resetOutlet")
      await this.$store.commit("outletModule/resetDetailOutlet")
    },

    async hapusBerhasil(res) {
      this.pageSetting.loading.list = true
      await this.$store.commit("snapMesinModule/resetListSnapMesin")
      this.$toast.success(res.msg)
      setTimeout(() => {
        window.location.reload()
      }, 500)
    },

    actionMoreMesin(id) {
      if (!this.pageSetting.more.mesinCard) {
        this.pageSetting.more.mesinCard = id
      } else {
        if (this.pageSetting.more.mesinCard === id) {
          this.pageSetting.more.mesinCard = false
        } else {
          this.pageSetting.more.mesinCard = id
        }
      }
    },

    turnOnModalAction(id) {
      if (this.pageSetting.modal.turnOnMesin) {
        this.pageSetting.modal.turnOnMesin = false
        this.actionId = ""
      } else {
        this.pageSetting.modal.turnOnMesin = true
        this.actionId = id
      }
    },

    turnOffModalAction(id) {
      if (this.pageSetting.modal.turnOffMesin) {
        this.pageSetting.modal.turnOffMesin = false
        this.actionId = ""
      } else {
        this.pageSetting.modal.turnOffMesin = true
        this.actionId = id
      }
    },

    deleteModalAction(id) {
      if (this.pageSetting.modal.deleteMesin) {
        this.pageSetting.modal.deleteMesin = false
        this.actionId = ""
      } else {
        this.pageSetting.modal.deleteMesin = true
        this.actionId = id
      }
    },
	  routeToSortinMesin(){
	  this.$router.push({
		  name: "SnapMesinSorting",
		  params: {
			  idoutlet: this.$route.query.idoutlet
		  }
	  })
	  }
      ,
    routeToDownloadQrOutlet(){
      window.open("https://owner-api.smartlink.id/masterData/external/get_multi_qr/QRIS_MESIN_"+this.$route.query.idoutlet);
      this.flutterDownload("https://owner-api.smartlink.id/masterData/external/get_multi_qr/QRIS_MESIN_"+this.$route.query.idoutlet)
    }

  },

  mounted() {
    this.initPage();
  },
  beforeDestroy() {
    this.clearData()
    this.resetFilter()
    this.unsubscribeMesin()
  },
  computed: {
    ...mapGetters("outletModule", {
      detailOutlet: "getDetailOutlet",
      outlets: "getOutlet",
    }),
    ...mapGetters("snapMesinModule", {
      listSnapMesin: "getListSnapMesin",
      reportConnectionMesin: "getReportConnectionMesin",
      latestVersionMesin: "getLatestVersionMesin",
      pagination: "getPagination",
      searchKey: "getSearch"
    }),
  }
}
</script>